import React from 'react';
import { Placeholder } from 'react-bootstrap';

const SkeletonCard: React.FunctionComponent<{ featured?: boolean }> = ({ featured }) => (
    <div className={`pricingTable${featured ? ' pricingTableFeatured' : ''}`}>
        <div className="pricingTableHeading">
            <Placeholder animation="wave" as="div">
                <Placeholder xs={5} />
            </Placeholder>
            <Placeholder animation="wave" as="div" className="mt-2">
                <Placeholder xs={7} />
            </Placeholder>
        </div>
        <div className="pricingTableContentTop">
            <Placeholder animation="wave" as="div">
                <Placeholder xs={3} /> <Placeholder xs={4} />
            </Placeholder>
            <Placeholder animation="wave" as="div" className="mt-2">
                <Placeholder xs={5} />
            </Placeholder>
        </div>
        <div className="pricingTableContent">
            <Placeholder animation="wave" as="ul" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li><Placeholder xs={8} /></li>
                <li><Placeholder xs={6} /></li>
                <li><Placeholder xs={9} /></li>
                <li><Placeholder xs={7} /></li>
            </Placeholder>
        </div>
        <div className="pricingTableActionWrapper">
            <Placeholder.Button
                variant="secondary"
                xs={7}
                aria-hidden="true"
                style={{ height: '2.3em', borderRadius: 0, backgroundColor: '#95785e', borderColor: '#95785e' }}
            />
        </div>
    </div>
);

const ProductListSkeleton: React.FunctionComponent = () => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <Placeholder animation="wave" as="h1">
                        <Placeholder xs={5} />
                    </Placeholder>
                    <Placeholder animation="wave" as="h5" className="mt-2">
                        <Placeholder xs={8} />
                    </Placeholder>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="pricingTableList">
                        <SkeletonCard />
                        <SkeletonCard featured />
                        <SkeletonCard />
                    </div>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-12">
                    <Placeholder animation="wave" as="p">
                        <Placeholder xs={9} /> <Placeholder xs={6} />
                    </Placeholder>
                </div>
            </div>
        </>
    );
};

export default ProductListSkeleton;
